import { Button, CircularProgress } from "@mui/material";
import { authPrimaryButtonSx } from "component/Input/darkFieldStyles";

const CustomButton = ({ sx, text, onClick, variant, type, loading, disabled, ...props }) => {
  return (
    <Button
      onClick={onClick}
      fullWidth
      type={type}
      disabled={loading || disabled}
      disableElevation
      variant="contained"
      {...props}
      sx={{
        my: 1,
        mx: "auto",
        display: "flex",
        ...authPrimaryButtonSx,
        ...sx,
      }}
    >
      {loading ? <CircularProgress size={20} sx={{ color: '#000' }} /> : text}
    </Button>
  );
};

export default CustomButton;
